import React from 'react';
import { getSurfaceLabel } from '../utils/mapHelpers';

function ResultsPanel({ routeData, alternativeRouteData, onClose }) {
    return (
        <div
            style={{
                position: 'absolute',
                top: '80px',
                right: '20px',
                width: '300px',
                maxHeight: 'calc(100vh - 100px)',
                overflow: 'auto',
                backgroundColor: 'white',
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                zIndex: 1000,
            }}
        >
            <div style={{ padding: '15px' }}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '15px',
                    }}
                >
                    <h3 style={{ margin: 0, fontSize: '16px' }}>📊 Résultats</h3>
                    <button
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '18px',
                            cursor: 'pointer',
                        }}
                    >
                        ✕
                    </button>
                </div>

                {/* Route standard */}
                {routeData && (
                    <div
                        style={{
                            marginBottom: '15px',
                            padding: '12px',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '8px',
                        }}
                    >
                        <h4 style={{ margin: '0 0 8px 0', fontSize: '14px', color: '#2196f3' }}>
                            Route standard
                        </h4>
                        <p style={{ margin: '5px 0', fontSize: '13px' }}>
                            <strong>{routeData.distance} km</strong>
                        </p>
                        <div style={{ fontSize: '11px', marginTop: '8px' }}>
                            {Object.entries(routeData.surfaces)
                                .filter(([s]) => s !== 'unknown' && s !== 'missing')
                                .sort(([, a], [, b]) => parseFloat(b.percentage) - parseFloat(a.percentage))
                                .slice(0, 3)
                                .map(([surface, data]) => (
                                    <div key={surface} style={{ margin: '3px 0' }}>
                                        {getSurfaceLabel(surface)}: {data.percentage}%
                                    </div>
                                ))}
                        </div>
                    </div>
                )}

                {/* Route alternative */}
                {alternativeRouteData && (
                    <div
                        style={{
                            padding: '12px',
                            backgroundColor: '#f1f8f4',
                            borderRadius: '8px',
                            border: '2px solid #4caf50',
                        }}
                    >
                        <h4 style={{ margin: '0 0 8px 0', fontSize: '14px', color: '#4caf50' }}>
                            Route alternative
                        </h4>
                        <p style={{ margin: '5px 0', fontSize: '13px' }}>
                            <strong>{alternativeRouteData.distance} km</strong>
                        </p>
                        {routeData && (
                            <p style={{ margin: '5px 0', fontSize: '11px', color: '#666' }}>
                                +{(parseFloat(alternativeRouteData.distance) - parseFloat(routeData.distance)).toFixed(1)} km
                            </p>
                        )}
                        <div style={{ fontSize: '11px', marginTop: '8px' }}>
                            {Object.entries(alternativeRouteData.surfaces)
                                .filter(([s]) => s !== 'unknown' && s !== 'missing')
                                .sort(([, a], [, b]) => parseFloat(b.percentage) - parseFloat(a.percentage))
                                .slice(0, 3)
                                .map(([surface, data]) => (
                                    <div key={surface} style={{ margin: '3px 0' }}>
                                        {getSurfaceLabel(surface)}: {data.percentage}%
                                    </div>
                                ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ResultsPanel;